import React from "react";
import SingleSecondShop from "../../../../components/SingleSecondShop/SingleSecondShop";
import SingleShop from "../../../../components/SingleShop/SingleShop";
import { useTranslation } from "react-i18next";
const cells = require("../../../../utils/biosmedlast.json");
const ShopBanner = ({ page }) => {
  const { t } = useTranslation();
  page = parseInt(page);
  let pagedata = cells.slice((page - 1) * 16, page * 16);
  let pagesizes = [page, page + 1, page + 2, page + 3, page + 4];
  return (
    <>
      <section className="shop-banner-area pt-120 pb-120">
        <div className="container">
          <div className="row mt-20">
            <div className="col-12">
              <h2>Cell Marque</h2>
              <p>{t("cellicerik")}</p>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="row">
                    {pagedata.map((e, i) => {
                      return (
                        <SingleShop
                          image={"img/cells/" + e.picture}
                          name="Table"
                          title={e.name}
                          index={e.seourl}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="basic-pagination basic-pagination-2 text-center mt-20">
                <ul>
                  <li>
                    <a
                      href={
                        page > 1 ? "/products/cell-marque/" + (page - 1) : ""
                      }
                    >
                      <i className="fa fa-angle-double-left"></i>
                    </a>
                  </li>
                  {pagesizes.map((e, i) => {
                    return (
                      <li>
                        <a href={"/products/cell-marque/" + e}>{e}</a>
                      </li>
                    );
                  })}

                  <li>
                    <a href={"/products/cell-marque/" + (page + 5)}>
                      <i className="fas fa-angle-double-right"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ShopBanner;
